import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@chakra-ui/react';

const ChablaButton = ({ onClick, width, children, ...rest }) => {
  return (
    <Button onClick={onClick} borderRadius={0} width={width} {...rest}>
      {children}
    </Button>
  );
};

ChablaButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.any,
  width: PropTypes.string,
};

ChablaButton.defaultProps = {
  onClick: () => {},
};

export default ChablaButton;
